import PricingListItem from '../../../../Domain/PricingListItem';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import PricingService from '../../../../Services/PricingService';
import React from 'react';
import AuthService from '../../../../Services/authService';

class PricingEditPanelDescription extends React.Component {
  static headerForEditPanel = 'Update';
  static headerForCreatePanel = 'Edit';
  static labelForSubmitButton = 'Save';
  static titleForCreate = 'Create';
  static titleForEdit = 'Edit';
  static itemType = PricingListItem;
  static serviceFunction = (edited) => PricingService.Post(edited);
  static messageOnSuccess =
    'Pricing has been updated!<br/><br/><strong>NOTE: If the fieldwork office differs from the owning office, please manually set the Markup or Owning Office Fee.</strong>';
  static overridefeeDisabled = (item) => {
    const loggedInUser = AuthService.getInstance().GetLoggedInUser();
    if (
      loggedInUser.roles.includes('Admin') ||
      loggedInUser.roles.includes('OpportunityAdmin') ||
      loggedInUser.userId === item.AcctReptId ||
      loggedInUser.userId === item.OpportunitySalesRepId ||
      loggedInUser.userId === item.AssignedTo ||
      loggedInUser.userId === item.OpportunityOfficeSalesContact
    ) {
      return false;
    }
    return item.OpportunityOfficeSameAsPricing !== 0 || item.StatusCode !== 4;
  };
  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'OfficeId',
          label: 'Fieldwork Office',
          className: 'col-12',
          type: InputTypesEnum.OfficeSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
          disabled: (item) => item.StatusCode !== 1,
        },
        {
          fieldName: 'CurrencyId',
          label: 'Currency',
          className: 'col-12',
          type: InputTypesEnum.ActiveCurrencySelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
          disabled: (item) => item.StatusCode !== 1,
        },
        {
          fieldName: 'AssignedTo',
          label: 'Assigned To',
          className: 'col-12',
          type: InputTypesEnum.UserSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
          disabled: (item) => {
            return !(item.StatusCode < 4 || (item.StatusCode === 4 && item.OpportunityOfficeSameAsPricing === 0));
          },
        },
        {
          fieldName: 'OverrideFee',
          label: 'Set Defined Owning Office Fee',
          className: 'col-12',
          type: InputTypesEnum.Checkbox,
          validityChecker: ValidityHelper.emptyValidityChecker,
          disabled: PricingEditPanelDescription.overridefeeDisabled,
          // roleKey: 'opportunity_admin_role_key',
        },
        {
          fieldName: 'OverrideFeeValue',
          label: 'Manually Set Owning Office Fee',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.emptyValidityChecker,
          disabled: (item) => {
            if (!item.OverrideFee) {
              return true;
            }
            return PricingEditPanelDescription.overridefeeDisabled(item);
          },
          // roleKey: 'opportunity_admin_role_key',
        },
        {
          fieldName: 'RoundFee',
          label: 'Round Owning Office Fee',
          className: 'col-12',
          type: InputTypesEnum.Checkbox,
          validityChecker: ValidityHelper.emptyValidityChecker,
          disabled: PricingEditPanelDescription.overridefeeDisabled,
          // roleKey: 'opportunity_admin_role_key',
        },
        {
          fieldName: 'MysteryShoppingPlatformPricingId',
          label: 'Mystery Shopping Platform Pricing',
          className: 'col-6',
          type: InputTypesEnum.MysteryShoppingPlatformPricingLookupSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
          disabled: PricingEditPanelDescription.overridefeeDisabled,
        },
        {
          fieldName: 'CallRecordingCostId',
          label: 'Call Recording Cost',
          className: 'col-6',
          type: InputTypesEnum.CallRecordingCostLookupSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
          disabled: PricingEditPanelDescription.overridefeeDisabled,
        },
        {
          fieldName: 'CsatcostId',
          label: 'CSAT Cost',
          className: 'col-6',
          type: InputTypesEnum.CsatCostLookupSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
          disabled: PricingEditPanelDescription.overridefeeDisabled,
        },
        {
          fieldName: 'IvrcostId',
          label: 'IVR Cost',
          className: 'col-6',
          type: InputTypesEnum.IvrCostLookupSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
          disabled: PricingEditPanelDescription.overridefeeDisabled,
        },
      ],
    },
  ];
}
export default PricingEditPanelDescription;
